import type { ProposalEvent, Maybe, ProposalEventType } from "query/graphql"

export const getGovernorProposalTxHash = (
  proposal: {
    events?: Maybe<Array<Pick<ProposalEvent, "type" | "txHash">>>
  },
  status?: ProposalEventType,
): string => {
  const { events } = proposal

  if (!events) return ""

  if (status) {
    const statusChangeFound = events.find((event) => event.type === status)

    return statusChangeFound?.txHash ?? ""
  }

  const lastStatusChange = events[events.length - 1]

  return lastStatusChange?.txHash || ""
}
